module.exports = __webpack_public_path__ + "static/media/logoEleccionesIni.2e2a971c.png";